/**
 * Flywheel-related constants
 */

/**
 * Default knowledgebase ID used by Flywheel flows.
 * This is the shared general knowledgebase that contains common
 * real estate knowledge and Speculo AI assistant information.
 */
export const DEFAULT_KNOWLEDGEBASE_ID = 'xj7IPJdgwuL3e4WItw8S';

/**
 * Days of the week used for Flywheel scheduling configuration
 */
export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];
